import * as React from 'react';

export class ErrorBoundary extends React.Component {
    state = {
        errored: false,
    }

    static getDerivedStateFromError (err: any) {
        return { errored: true };
    }

    componentDidCatch (error: any, info: any) {
        console.log(error, info);
    }

    render () {
        const { errored } = this.state;
        const { children } = this.props;

        return errored ? null : children;
    }
}
